import * as t from "io-ts";
import { nullable } from "./index";
export const createStopDocumentTypes = ({ dateTime, }) => {
    const stopDocumentWithoutUrlT = t.strict({
        id: t.string,
        name: t.string,
        fileType: t.string,
        documentType: t.string,
        time: dateTime,
        addedAt: dateTime,
        addedBy: t.union([
            t.strict({
                userType: t.literal("DISPATCHER"),
                dispatcherId: t.string,
            }),
            t.strict({ userType: t.literal("PUBLIC_API") }),
        ]),
    });
    const stopDocumentT = t.intersection([
        stopDocumentWithoutUrlT,
        t.strict({
            url: t.string,
            urlNew: t.string,
            urlPreview: nullable(t.string),
            urlPreviewNew: nullable(t.string),
        }),
    ]);
    const stopDocumentsT = t.array(stopDocumentT);
    const stopDocumentsWithoutUrlT = t.array(stopDocumentWithoutUrlT);
    const stopDocumentsByStopIdT = t.record(t.string, stopDocumentsT);
    return {
        stopDocumentT,
        stopDocumentsT,
        stopDocumentsWithoutUrlT,
        stopDocumentsByStopIdT,
    };
};
//# sourceMappingURL=stop-document.js.map